document.addEventListener("DOMContentLoaded", function(){
    const filterDropdown = document.querySelectorAll('.filter-dropdown__dropdown')
    filterDropdown.forEach(dropdown => {
        const toggleButton = dropdown.querySelector('.filter-dropdown__button')
        const buttonText = toggleButton.innerText
        const clearButton = dropdown.querySelector('.filter-dropdown__clear')
        const checkboxes = dropdown.querySelectorAll('.custom-checkbox')
        var checkedItems = 0

        // check if there is any checked checkbox and change button style
        for (let i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked) {
                checkedItems += 1
            }
            
            if(checkedItems > 0){
                toggleButton.classList.add('filter-dropdown__button--active')
                toggleButton.innerText = `${buttonText} (${checkedItems})`
            }
        }

        checkboxes.forEach(thisCheckbox => {
            // watch checkbox "change" event
            thisCheckbox.addEventListener('change', (event) => {

                if (event.currentTarget.checked) {
                    // is checked
                    checkedItems += 1
                } else {
                    // is not checked
                    checkedItems -= 1
                }

                // if there is any checked checkbox, style the button and change the button text
                for (let i = 0; i < checkboxes.length; i++) {
                    if (checkboxes[i].checked) {
                        toggleButton.classList.add('filter-dropdown__button--active')
                        toggleButton.innerText = `${buttonText} (${checkedItems})`
                        return;
                    } else {
                        toggleButton.classList.remove('filter-dropdown__button--active')
                        toggleButton.innerText = `${buttonText}`
                    }
                }
            })
        })

        // Uncheck all checkboxes on click
        clearButton.onclick = () => {
            checkboxes.forEach(checkbox => {
                checkbox.checked = false
            })

            // Reset 'checkedItems' count and remove the "active" button style
            checkedItems = 0
            toggleButton.innerText = `${buttonText}`
            toggleButton.classList.remove('filter-dropdown__button--active')
        }
    })
})